import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Input, Checkbox, Textarea } from 'components/Forms'

const BillingDetails: FC<{ context: 'project' | 'punchCard' | 'shift' }> = ({ context }) => {
  const { payExportType } = useSelector((state: MStore.RootState) => state.settings)

  return (
    <>
      <Checkbox module="components.billingDetails" translation="nonBillable" name="billingDetails.nonBillable" />
      <Input module="components.billingDetails" translation="billingId" name="billingDetails.billingId" />
      {/* Memo fields used for apogee integration */}
      {payExportType === 'apogee' ? (
        <>
          <Textarea module="components.billingDetails" translation="memo1" name="billingDetails.memo1" rows="1" maxLength="30" />
          <Textarea module="components.billingDetails" translation="memo2" name="billingDetails.memo2" rows="1" maxLength="30" />
          {/* Memo3 should only come from the project */}
          {context === 'project' ? (
            <Textarea module="components.billingDetails" translation="memo3" name="billingDetails.memo3" rows="1" maxLength="30" />
          ) : null}
        </>
      ) : null}
    </>
  )
}

export default BillingDetails
